import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-center bg-blue-800 text-white p-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-3xl md:text-5xl font-bold mb-3" }, "Riks10 Spelschema", -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, _hoisted_3))
}